import axios from "axios";
import { endpoints } from "./endpoints";
// import qs from 'qs'
// import { setCookie, deleteCookie, getCookie } from '../helpers/helperFunctions'

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export const apiPut = {
  updateLoginCustomer,
  updateSiteProperties,
  updateImageByKey,
  updateVendorCategories,
};

// Removed unused getCookie function

async function updateLoginCustomer({ customer_num }) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_CUSTOMER}${customer_num}/${endpoints.CSFA_CHANGE_LOGIN_CUST}`;

  const response = await axios.put(
    url,
    {},
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      xsrfCookieName: "csrftoken",
      xsrfHeaderName: "X-CSRFTOKEN",
    },
  );

  return response;
}

async function updateSiteProperties({
  primary_color,
  secondary_color,
  title,
  allow_approval,
}) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_SITE_ADMIN}${endpoints.CSFA_UPDATE_SITE_PROPERTIES}`;

  const response = await axios.put(
    url,
    { primary_color, secondary_color, title, allow_approval },
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      xsrfCookieName: "csrftoken",
      xsrfHeaderName: "X-CSRFTOKEN",
    },
  );

  return response;
}

async function updateImageByKey({
  end_date,
  start_date,
  label,
  image_type,
  image, // should be a blob URL or File
  filterObject,
  id,
  customer_num,
  is_parent_number,
  is_aftermarket_number,
}) {
  const url =
    endpoints.MITCO_API_URL +
    endpoints.CSFA_BASE +
    endpoints.CSFA_SITE_ADMIN +
    id +
    "/" +
    endpoints.CSFA_UPDATE_IMAGES;

  let imageFile;

  // If `image` is a blob URL (e.g., starts with "blob:")
  if (typeof image === "string") {
    if (image.startsWith("blob:") || image.startsWith("http")) {
      // Fetch the image from either blob URL or HTTP URL
      const blobResponse = await fetch(image);
      const blob = await blobResponse.blob();

      imageFile = new File([blob], label + ".jpeg", {
        type: blob.type || "image/jpeg",
      });
    }
  } else if (image instanceof File) {
    // Already a File object (e.g. from <input type="file" />)
    imageFile = image;
  }

  const formData = new FormData();
  formData.append("image", imageFile);
  formData.append("label", label);
  formData.append("filterObject", JSON.stringify(filterObject));
  formData.append("start_date", start_date);
  formData.append("end_date", end_date);
  formData.append("image_type", image_type);
  if (customer_num != null) {
    formData.append("customer_num", customer_num);
  }
  if (is_parent_number != null) {
    formData.append("is_parent_number", is_parent_number);
  }
  if (is_aftermarket_number != null) {
    formData.append("is_aftermarket_number", is_aftermarket_number);
  }

  const response = await axios.put(url, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFTOKEN",
  });

  return response;
}

async function updateVendorCategories(userId, vendorCategories) {
  const url = `${endpoints.MITCO_API_URL}${endpoints.CSFA_BASE}${endpoints.CSFA_SITE_ADMIN}${userId}/update_vendor_categories/`;

  const response = await axios.put(
    url,
    { vendor_categories: vendorCategories },
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      xsrfCookieName: "csrftoken",
      xsrfHeaderName: "X-CSRFTOKEN",
    },
  );

  return response;
}
